import { css, styled } from 'next-yak';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import { scale020, scale030 } from '@xing-com/tokens';

import type { SkeletonFacepileSize } from '.';

type FacepileTProps = {
  $size: SkeletonFacepileSize;
};

// *** Components ***
const ContainerElement = createPolymorphicElement('div');

export const Container = styled(ContainerElement)<FacepileTProps>`
  display: flex;
  flex-shrink: 0;

  ${({ $size }) =>
    $size === 'small' &&
    css`
      gap: ${scale020};
    `};
  ${({ $size }) =>
    $size === 'medium' &&
    css`
      gap: ${scale030};
    `};
`;
